module.exports = __webpack_public_path__ + "static/img/yuzhigang.44d843a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yuzhigang.png
// module id = yOfo
// module chunks = 1